import { ref } from 'vue'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

const deferred = ref<BeforeInstallPromptEvent | null>(null)
const installable = ref(false)

// Capture the install opportunity so we can offer it contextually instead of
// letting the browser show (or suppress) its own prompt on load.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  deferred.value = e as BeforeInstallPromptEvent
  installable.value = true
})
window.addEventListener('appinstalled', () => {
  deferred.value = null
  installable.value = false
})

export function useInstallPrompt() {
  async function promptInstall() {
    if (!deferred.value) return
    await deferred.value.prompt()
    deferred.value = null
    installable.value = false
  }
  return { installable, promptInstall }
}
